import Background from "../ui/Background";
import { SignUp as ClerkSignUp } from "@clerk/clerk-react";

const SignUp = () => {
    // Set up paths with org context
    const afterSignUpUrl = '/dashboard';
    const fallbackRedirectUrl = '/dashboard';

    return (
        <Background>
            <div className="auth-page">
                <div className="container flex justify-center">
                    <ClerkSignUp
                        signInUrl={"/sign-in"}
                        routing="path"
                        path="/sign-up"
                        redirectUrl="/sign-up/sso-callback"
                        afterSignUpUrl={afterSignUpUrl}
                        fallbackRedirectUrl={fallbackRedirectUrl}
                        appearance={{
                            layout: {
                                socialButtonsVariant: 'iconButton',
                                showOptionalFields: false,
                            },
                        }}
                    />
                </div>
            </div>
        </Background>
    );
};

export default SignUp; 